import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Images from "../../Assets/Images/Index";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const handleNavigate = useCallback(
    (path) => {
      navigate(path);
      setIsOpen(false);
    },
    [navigate]
  );

  const handleNavigateAdmin = () => {
    window.open("https://admin.qflyers.com/", "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > window.innerHeight * 0.1);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header">
      <nav
        className={`nav fixed top-0 left-0 w-full transition-all duration-300 ${scrolled ? "bg-white shadow-md" : "bg-transparent"
          }`}
      >
        <div className="nav-logo">
          <img
            onClick={() => handleNavigate("/")}
            src={Images.logo_bg}
            alt="Logo"
            className="logo"
          />
        </div>

        <ul className={`nav-list ${isOpen ? "nav-list-active" : ""}`}>
          {[
            { name: "Home", path: "/" },
            { name: "Template", path: "/Template" },
            { name: "Pricing", path: "/plan" },
            { name: "Contact Us", path: "/Contact" },
            { name: "Goals", path: "/Goal" },
          ].map((item) => (
            <li
              key={item.path}
              onClick={() => handleNavigate(item.path)}
              className={location.pathname === item.path ? "selected" : ""}
            >
              {item.name}
            </li>
          ))}
          <div className="for-mobile">
            <button className="outline" onClick={handleNavigateAdmin}>
              Login / Register
            </button>
          </div>
        </ul>

        <div className="nav-buttons">
          <button className="outline" onClick={handleNavigateAdmin}>
            Login / Register
          </button>
        </div>

        <button
          className="menu-btn"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>
    </header>
  );
}

export default Header;
